import MOLocation from "./MOLocation"

/** Signature of a logging function */
export interface LogFn {
  (message?: any, ...optionalParams: any[]): void
}

/** Basic logger interface */
export interface Logger {
  log: LogFn
  warn: LogFn
  error: LogFn
}

declare global {
  interface Window {
    sendLogToNative: any
  }
}


const NO_OP: LogFn = (message?: any, ...optionalParams: any[]) => {}

/** Logger which outputs to the browser console */
export class ConsoleLogger implements Logger {
  readonly log: LogFn
  readonly warn: LogFn
  readonly error: LogFn

  constructor() {
    const lsLogLevel = MOLocation.getURLParamValue("lsloglevel")
    let logLevel = "error"
    if (lsLogLevel === "log" || lsLogLevel === "warn") {
      logLevel = lsLogLevel
    }
    const level = logLevel

    this.error = console.error.bind(console)

    if (level === "error") {
      this.warn = NO_OP
      this.log = NO_OP

      return
    }

    this.warn = console.warn.bind(console)

    if (level === "warn") {
      this.log = NO_OP

      return
    }

    if (window.sendLogToNative) {
      this.log = window.sendLogToNative
    } else {
      this.log = console.log.bind(console)
    }
  }
}
